<app-menu [isBasic]="true"></app-menu>

<ng-content></ng-content>
